export const buildQueryParamForStringOrNull = (queryParams: URLSearchParams, key: string, value: null | string) => {
  if (value === null) {
    queryParams.append(key, '');
  } else {
    queryParams.append(key, value as string);
  }
};
